import React, { useRef, useState } from "react";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import LikeSvg from "../assets/images/like.svg";
import DislikeSvg from "../assets/images/dislike.svg";
import CommentSvg from "../assets/images/comment.svg";
import ForwardSvg from "../assets/images/forward.svg";
import MenuSvg from "../assets/images/menu.svg";
import config from "../config";
import detectLanguage from "./promotedPreviewStyles";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
function VideoEndcard({ preview }) {
  //   const handleDownloadPreview = () => {
  //     const previewElement = document.querySelector('.download-preview');
  //     toBlob(previewElement).then(function (blob) {
  //       saveAs(blob, `${preview.name}.png`);
  //     });
  //   };

  const videoRef = useRef(null);
  const [showImage, setShowImage] = useState(false);

  // Function to handle video end event
  const handleVideoEnd = () => {
    // Pause the video
    videoRef.current.pause();
    // Show the image
    setShowImage(true);
  };

  // Function to handle image click to replay the video
  const handleImageClick = () => {
    // Play the video
    setShowImage((prevState) => !prevState);
    videoRef.current.play();
    // Hide the image
  };
  const { heading, descrip } = detectLanguage(preview.head_line || config.HEADLINE)

  return (
    <div>
      {preview.stream_type === undefined ? <>
        <CreativeNameDisplay preview={preview} />
      </> : null}
      <div className="preview-inner">
        <div className="h-full">
          <div className="min-h-[40%] max-h-[40%] rounded-t-[24px] bg-black d-flex items-center relative">
            {!showImage && (
              <video
                ref={videoRef}
                onEnded={handleVideoEnd}
                src={
                  preview.post_video ||
                  "https://video.twimg.com/ext_tw_video/1750496838581723136/pu/vid/avc1/1280x720/nVwBnsdb0XrI58a6.mp4"
                }
                type="video/mp4"
                style={{ width: "100%", height: "100%" }}
                controls
              ></video>
            )}
            {showImage && (
              <img
                src={
                  preview.img_urls ||
                  "https://ads.way2news.com/uploads/1704261408148.jpg"
                }
                alt="Placeholder"
                onClick={handleImageClick}
                className="rounded-t-[24px] overflow-hidden object-cover"
              />
            )}
            {showImage && <SlIcon library="lucide" name="x" className="absolute cursor-pointer top-2 right-2 text-red-600" onClick={handleImageClick} />}
          </div>
          <div className="flex flex-col justify-between min-h-[60%]">
            <div className="px-2 mt-2">
              <h5 style={heading}>{preview.head_line || config.HEADLINE}</h5>
              <p style={descrip} className="text-base">
                {(preview.description || config.DESCRIPTION)
                }
              </p>
            </div>
            <div>
              <div className="px-2 text-xs mb-3">
                <div className="d-flex gap-1 items-center">
                  <SlIcon className="text-gray-400" name="clock-4" library="lucide" />
                  <span className="text-bold">7m ago</span>
                  <span className="text-gray-400">/ 2 of 196 Stories</span>
                </div>
                <div className="border-gray-200 my-2 px-0 py-0 border-b"></div>
                <div className="d-flex justify-between items-center my-0 px-2 py-0">
                  <div className="d-flex gap-2 items-center my-1">
                    <div className="d-flex items-center gap-[2px]">
                      <img src={LikeSvg} alt="like"></img>
                      <span className="text-gray-400">720</span>
                    </div>
                    <div className="d-flex items-center gap-[2px]">
                      <img src={DislikeSvg} alt="dislike"></img>
                      <span className="text-gray-400">18</span>
                    </div>
                    <div className="d-flex items-center gap-[2px]">
                      <img src={CommentSvg} alt="comment"></img>
                      <span className="text-gray-400">4</span>
                    </div>
                  </div>
                  <div className="d-flex gap-2 items-center my-1">
                    <img src={MenuSvg} alt="menu"></img>
                    <img src={ForwardSvg} alt="forward"></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoEndcard;
